import { render, staticRenderFns } from "./koulutussuunnitelma-card.vue?vue&type=template&id=c9e60f9e&scoped=true&"
import script from "./koulutussuunnitelma-card.vue?vue&type=script&lang=ts&"
export * from "./koulutussuunnitelma-card.vue?vue&type=script&lang=ts&"
import style0 from "./koulutussuunnitelma-card.vue?vue&type=style&index=0&id=c9e60f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e60f9e",
  null
  
)

export default component.exports